import React from 'react'

import styled from 'styled-components'

import MainFooter from '../../views/Main/MainFooter/MainFooter'
import MainHeader from '../MainHeader'

const StyledContainer = styled.div`
	box-sizing: border-box;
`

export default function Layout({ children, darkColor, eSignature }) {
	return (
		<>
			<MainHeader darkColor={darkColor} eSignature={eSignature} />
			<StyledContainer>{children}</StyledContainer>
			<MainFooter />
		</>
	)
}
